
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';

interface AppNameSectionProps {
  form: UseFormReturn<any>;
  value: string;
  onChange: (value: string) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AppNameSection: React.FC<AppNameSectionProps> = ({ 
  form, 
  value, 
  onChange, 
  handleInputChange 
}) => {
  const { t } = useTranslationUtils();

  return (
    <FormField
      control={form.control}
      name="app_name"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('admin.appName', 'Application Name')}</FormLabel>
          <FormControl>
            <Input
              id="app_name"
              name="app_name"
              value={value}
              onChange={(e) => {
                handleInputChange(e);
                field.onChange(e);
                onChange(e.target.value);
              }}
              placeholder="KFC Antilles"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default AppNameSection;
